import React from 'react';
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import './App.css';
import { Route, Routes, Navigate, Outlet } from "react-router-dom";
import AgeGate from './components/PageComponents/AgeGate.jsx';
import PageHeader from './components/PageComponents/PageHeader.jsx';
import PageFooter from './components/PageComponents/PageFooter.jsx';
import HomePage from './components/PageComponents/HomePage.jsx';
import XRPage from './components/PageComponents/3XRPage.jsx';
import FAQPage from './components/PageComponents/FAQPage.jsx';
import DevlogPage from './components/PageComponents/DevlogPage.jsx';
import JobsPage from './components/PageComponents/JobsPage.jsx';
import LonelyHandsPage from './components/PageComponents/LonelyHandsPage.jsx';
import ScrollToTop from './components/ScrollToTop';
import SpineCompanion from './components/SpineCompanion.jsx';       // adjust path to wherever these actually live
import CompanionNarrator from './components/CompanionNarrator.jsx';

// Initialize Google Analytics
ReactGA.initialize("G-ES6YZLZ7KK");

const COMPANION_EXCLUDED_PATHS = ['/faq', '/jobs', '/devlog', '/games/3xr', '/games/lonelyhands'];

function isCompanionExcluded(pathname) {
  return COMPANION_EXCLUDED_PATHS.some((excluded) => pathname.startsWith(excluded));
}

// The invisible tracking component
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Send a pageview event to Google every time the route changes
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return null; 
};

// 1. Define the Layout Component inside App or separate file
// Inside App.js
const MainLayout = () => {
  const location = useLocation();
  const showCompanion = !isCompanionExcluded(location.pathname);

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh', 
      backgroundColor: '#0b132b', 
      color: '#e2e8f0',
      overflowX: 'hidden' // <-- ADD THIS LINE!
    }}>
      <AnalyticsTracker />
      <ScrollToTop />
      <AgeGate />
      <PageHeader />
      <div style={{ flex: 1, width: '100%' }}> 
        <Outlet />
      </div>
      <PageFooter />
      {showCompanion && (
        <>
          <SpineCompanion />
          <CompanionNarrator />
        </>
      )}
    </div>
  );
};

function App() {
  return (
    <Routes>
      {/* 2. Wrap everything in the MainLayout */}
      <Route element={<MainLayout />}>
        <Route path='/' element={<Navigate to='/home' replace />} />
        <Route path='/home' element={<HomePage />} />
        
        {/* Games Routes */}
        <Route path='/games/3xr' element={<XRPage />} />
        <Route path="/games/lonelyhands" element={<LonelyHandsPage />} />
        <Route path='/faq' element={<FAQPage />} />
        <Route path='/devlog' element={<DevlogPage />} />
        <Route path='/jobs' element={<JobsPage />} />
        {/* Fallback */}
        <Route path='*' element={<div style={{color: 'white', textAlign: 'center', marginTop: '50px'}}>404: There's nothing to see here!</div>} />
      </Route>
    </Routes>
  );
}

export default App;